'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESearchTopics = exports.DETopicsBlank = undefined;

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _core = require('@blueprintjs/core');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

var IsOpen = (0, _glamorous2.default)(_core.Button)({
  marginBottom: 10
});

var StyledTopics = _glamorous2.default.div({
  display: 'flex',
  justifyContent: 'center'
}, function (_ref) {
  var isNarrow = _ref.isNarrow;

  return {
    flexWrap: isNarrow ? 'nowrap' : 'wrap',
    flexDirection: isNarrow ? 'column' : 'row'
  };
});

var Topic = _glamorous2.default.div({
  padding: 10
}, function (_ref2) {
  var isNarrow = _ref2.isNarrow;
  return {
    width: isNarrow ? '100%' : 300
  };
});

var Blank = (0, _glamorous2.default)(_core.NonIdealState)({
  paddingTop: 20,
  paddingBottom: 20
});

var DETopicsBlank = exports.DETopicsBlank = function DETopicsBlank(_ref3) {
  var blankLabel = _ref3.blankLabel;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(Blank, { visual: 'circle', className: (0, _classnames2.default)(_core.Classes.DARK), description: blankLabel })
  );
};

DETopicsBlank.propTypes = {
  blankLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

var Topics = function Topics(_ref4) {
  var isOpen = _ref4.isOpen,
      items = _ref4.items,
      onChangeIsOpen = _ref4.onChangeIsOpen,
      format = _ref4.format,
      isRtl = _ref4.isRtl,
      isNarrow = _ref4.isNarrow,
      selectTopic = _ref4.selectTopic,
      isLoading = _ref4.isLoading,
      collapseLabel = _ref4.collapseLabel;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(
      IsOpen,
      {
        className: (0, _classnames2.default)(_core.Classes.LARGE),
        iconName: isRtl ? (0, _classnames2.default)({ 'chevron-up': isOpen, 'chevron-down': !isOpen }) : 'layers',
        rightIconName: isRtl ? 'layers' : (0, _classnames2.default)({ 'chevron-up': isOpen, 'chevron-down': !isOpen }),
        onClick: onChangeIsOpen,
        loading: isLoading,
        intent: isLoading ? _core.Intent.PRIMARY : _core.Intent.NONE
      },
      collapseLabel
    ),
    _react2.default.createElement(
      _core.Collapse,
      { isOpen: isOpen && !isLoading },
      _react2.default.createElement(
        StyledTopics,
        { isNarrow: isNarrow },
        (0, _map2.default)(function (topic) {
          return _react2.default.createElement(
            Topic,
            { key: topic.id, isNarrow: isNarrow },
            _react2.default.createElement(_.DESearchTopic, _extends({}, topic, { selectTopic: selectTopic, isRtl: isRtl }))
          );
        })(items)
      )
    )
  );
};

Topics.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  })),
  isOpen: _propTypes2.default.bool,
  onChangeIsOpen: _propTypes2.default.func.isRequired,
  selectTopic: _propTypes2.default.func,
  format: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isNarrow: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  collapseLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};

Topics.defaultProps = {
  items: []
};

var DESearchTopics = exports.DESearchTopics = (0, _.withListBlank)(DETopicsBlank)(Topics);


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-topics/index.js
// module id = 2025
// module chunks = 0